/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"

import styles from "./ReportsContainer.module.scss"
import notificationsServices from "../../services/notificationsServices"
import { getPageCount } from "../CommunityQuestionsContainer"
import reportServices from "../../services/reportServices"
import { setNotifications } from "../../actions/notifications/notificationsActions"
import ReportsList from "../../components/Reports/ReportsList/ReportsList"
import Pagination from "../../components/elements/Pagination"
import ContentWithSidebars from "../../components/templates/ContentWithSidebars"

const ReportsContainer = () => {
  // Admin request: hide (comment out) reports content on the admin home/reports page.
  // Toggle this back to true to restore the reports feed UI.
  const SHOW_REPORTS_CONTENT = false

  const [reports, setReports] = useState([])
  const [reportsCount, setReportsCount] = useState()
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(1)

  const getNotif = () => {
    notificationsServices
      .getNotificationsAdmin()
      .then(({ data }) => {
        dispatch(
          setNotifications({
            system_notifications: data.system_notifications_count,
          }),
        )
      })
      .catch(console.log)
  }

  const getReports = (currentPage) =>
    reportServices
      .getReports(currentPage)
      .then(({ data }) => {
        setReports(data.reports)
        setReportsCount(data.reports_count)
      })
      .catch(console.log)

  useEffect(() => {
    // Keep notifications count in sync, but hide the reports list content
    getNotif()
    if (SHOW_REPORTS_CONTENT) {
      getReports(currentPage)
    }
  }, [currentPage])

  return (
    <div className={styles.wrapper}>
      <ContentWithSidebars bottomSidebar={() => {}}>
        {SHOW_REPORTS_CONTENT ? (
          <>
            <ReportsList data={reports} />

            <div className={styles.paggination}>
              <Pagination
                currentPageNumber={currentPage}
                totalPageCount={getPageCount(reportsCount, 6)}
                onSelect={setCurrentPage}
              />
            </div>
          </>
        ) : null}
      </ContentWithSidebars>
    </div>
  )
}

export default ReportsContainer
